import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={` https://order.codefusion.tech/restaurants/z1n6s0Q1U12JBeruNx0e/locations/${locationId}`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} maxWidth="270px" alt="About" />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={` https://order.codefusion.tech/restaurants/z1n6s0Q1U12JBeruNx0e/locations/${locationId}`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} maxWidth="260px" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
